import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    moduleCheck: false,
    dogResults: []
  },
  getters: {
    getModuleCheck: state => {
      return state.moduleCheck
    },
    getDogResults: state => {
      return state.dogResults
    }
  },
  mutations: {
    setModulecheck (state,check) {
      state.moduleCheck = check
    },
    setDogResults (state,res) {
      state.dogResults = res
    }
  }
})
